<ion-content class="container">
  <ion-row class="p-0  headerBreadcrumb">
    <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="center-content">
      <div class="d-flex headerBreadcrumb">
        <img src="././assets/icon/backArrow.svg" class="cp" (click)="onClickGoToVariablePay('Setup')">
        <label class="font_semibold fs-16 ml-5 mt-5 black_color">
          <span class="cp" (click)="onClickGoToVariablePay('Setup')">Variable Pay / Setup</span> / <span [style.color]="buttonColorName">Variable Pay Letter</span></label>
      </div>
    </ion-col>
  </ion-row>
  <div class="p-10 ml-20">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <mat-form-field class="w-150 mat-height40 mat-input-style">
          <mat-select placeholder="Select Year" [(ngModel)]="selectedYear" (selectionChange)="onYearChange($event)" >
            <mat-option [value]="item.year" *ngFor="let item of getIncrementFyYearList" >{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col> 
    </ion-row>
  
    <ion-row>
      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
        <p class="Company-Letter-head-title">Company Letter head</p>
      </ion-col>
    </ion-row>
  
    <ion-row>
      <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
        <div class="cardBox mb-20 p-20">
            <button (click)="getVPPolicyFile()" class="downloadImportFileBtn font_medium mr-30 mt-10" [style.background-color]="buttonColorName " (click)="onClickDownloadLetterHeadFile()">
              <img class="mr-10" src="././assets/icon/downloadWhite.svg">Letter Head Download</button>
            <div *ngIf="!showBrowseBtn" class="w-100 upload-box display-center pt-25 pb-25 mt-20 cp"
              (click)="browseImage.click()">
              <div class="d-flex text-center">
                <label class="uploadBtn text_center font_regular cp"><span class="material-icons">upload_file</span><br>Browse File</label>
                <input #browseImage type="file" (change)="onFileSelected($event)" style="display:none;">
              </div>
            </div>
            <div *ngIf="showBrowseBtn" class="w-100 upload-box display-center pt-25 pb-25 mt-20 cp">
              <div class="d-flex mb-50 mt-50">
                <div class="verticle-center mr-20">
                  <img src="././assets/icon/successImport.svg">
                </div>
                <div class="flex-column">
                  <label class="fs-14 font_medium text_gray1 mb-10">File Uploaded Successfully.</label>
                  <div class="d-flex">
                    <label class="fs-12 blue font_medium cl-black mx-width">{{fileName}}</label>
                    <span class="material-icons fs-12" (click)="onCloseFile()">close</span>
                  </div>
                </div>
              </div>
          </div>
          <div class="upload-file-validation">
              <p>One file only | 10 MB Limits</p>
              <button type="button" [disabled]="isDisabledLetterHeadBtn" (click)="onSendCompanyLetterheadFile()">Save</button>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </div>


  

  <div class="p-10 ml-20">
    <ion-row>
      <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
        <div class="formLabelSemiBoldfs14 mb-5">Fiscal year - <span [style.color]="buttonColorName">{{sharedService.transformYearToFyFormat(selectedYearForLetterHead)}}</span>
        </div>

        <mat-form-field class="w-150 mat-height40 mat-input-style">
          <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForLetterHead" (selectionChange)="getFrequencies()">
            <mat-option [value]="item.year" *ngFor="let item of getIncrementFyYearList">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>

      <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
        <div class="formLabelSemiBoldfs14 mb-5">Period<span class="red-cl">&nbsp;*</span>
        </div>

        <mat-form-field class="w250 mat-height40 mat-input-style">
          <mat-select placeholder="Select Period" [(ngModel)]="frequencyPeriod">
            <mat-option *ngFor="let month of variablePeriodFrquency" [value]="month">
              {{ month }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
        <div class="formLabelBoldfs16 mb-5 mt-10">Variable Pay Letter</div>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size-sm="1" size-md="1" size-lg="1" size-xs="1" class="mr-20">
        <button type="button" class="add_btn fs-14" [style.background-color]="buttonColorName"
          (click)="VPgetLetterOfUsers()" [disabled]="frequencyPeriod == null"
          [ngClass]="{'disabled': frequencyPeriod == null}">
          <label *ngIf="showVariablePayLetter"><span class="material-icons fs-20 mr-5">visibility_off</span>Hide</label>
          <label *ngIf="!showVariablePayLetter"><span class="material-icons fs-20 mr-5">visibility</span>View</label></button>
      </ion-col>

      <ion-col size-sm="1" size-md="1" size-lg="1" size-xs="1">
        <button type="button" class="add_btn fs-14 center-content" [style.background-color]="buttonColorName"
          (click)="editVariablePay()" [disabled]="frequencyPeriod == null"
          [ngClass]="{'disabled': frequencyPeriod == null}">
          <span class="material-icons fs-20 mr-5">edit_square</span>Edit</button>
      </ion-col>
    </ion-row>
  </div>

  <div class="p-10 ml-20" *ngIf="showVariablePayLetter">
    <div class="variable-pay-container">
      <div class="main-container">
        <iframe
          [src]="vpLetterPdfUrl"
          style="width: 70%; height: 100%; border: none;">
        </iframe>
      </div>
    </div>
  </div>
</ion-content>